export enum ShrimpDataUploadType {
  Production = 'production',
  Sanitation = 'sanitation',
}
